<template>
  <div class="px-4 border rounded-10 bg-slate-100 dark:bg-zinc-700 border-slate-200 dark:border-zinc-600" data-testid="viewer-versions-skeleton">
    <div class="py-4 flex items-center gap-2.5">
      <div class="w-40 h-40 border rounded-md border-slate-200 bg-white animate-pulse"></div>
      <div class="w-40 flex flex-col gap-1 flex-grow animate-pulse">
        <div class="w-2/6 h-4 mt-2 rounded bg-slate-200"></div>
        <div class="w-4/6 h-4 mt-2 rounded bg-slate-200"></div>
        <div class="w-1/6 h-4 mt-2 rounded bg-slate-200"></div>
        <div class="w-1/6 h-4 mt-2 rounded bg-slate-200"></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup></script>
